import { useState } from "react";
import { Ban, Trash2, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { HostCalendar } from "@/components/host/HostCalendar";

export function HostBlocks({ trips, listings, addBlock, removeBlock }) {
  const { t } = useTranslation();
  const [carId, setCarId] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [reason, setReason] = useState("");

  const submit = () => {
    if (!carId || !start || !end) return;
    addBlock(carId, start, end, reason, () => { setStart(""); setEnd(""); setReason(""); });
  };

  const allBlocks = listings.flatMap((c) => (c.blocks || []).map((b) => ({ car: c, b })));

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="host-calendar-tab">
      <HostCalendar trips={trips} listings={listings} />

      <div className="space-y-4">
        <div className="bg-blue-50 border border-blue-100 rounded-2xl p-5" data-testid="turo-sync-card">
          <h3 className="font-heading font-semibold text-blue-900 flex items-center gap-2"><RefreshCw size={16} /> {t("hostBlocks.turoSync")}</h3>
          <p className="text-blue-800/80 text-sm mt-1.5">{t("hostBlocks.turoSyncDesc")}</p>
          <button onClick={() => setReason(t("hostBlocks.turoReason"))} data-testid="turo-quickfill"
            className="mt-3 text-xs font-semibold text-blue-700 bg-white border border-blue-200 rounded-full px-3 py-1.5 hover:bg-blue-50 transition-colors">+ {t("hostBlocks.turoReason")}</button>
        </div>

        <div className="bg-white rounded-2xl shadow-card border border-slate-100 p-6 space-y-4">
          <h3 className="font-heading font-semibold text-slate-900 flex items-center gap-2"><Ban size={16} /> {t("hostBlocks.blockDates")}</h3>
          <select value={carId} onChange={(e) => setCarId(e.target.value)} data-testid="block-car-select" className="belo-input w-full">
            <option value="">{t("hostBlocks.selectVehicle")}</option>
            {listings.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <div className="grid grid-cols-2 gap-3">
            <input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="block-start" className="belo-input w-full" />
            <input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="block-end" className="belo-input w-full" />
          </div>
          <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder={t("hostBlocks.reasonOptional")} data-testid="block-reason" className="belo-input w-full" />
          <button onClick={submit} disabled={!carId || !start || !end} data-testid="block-submit" className="bg-blue-600 text-white px-5 py-2.5 rounded-full font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-50">{t("hostBlocks.blockThese")}</button>

          <div className="pt-2 space-y-2">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">{t("hostBlocks.currentBlocks")}</p>
            {allBlocks.length === 0 ? (
              <p className="text-sm text-slate-400" data-testid="blocks-empty">{t("hostBlocks.noBlocked")}</p>
            ) : (
              allBlocks.map(({ car, b }) => (
                <div key={b.id} data-testid={`block-row-${b.id}`} className="flex items-center justify-between text-sm border border-slate-100 rounded-xl px-3 py-2">
                  <span className="text-slate-600"><b className="text-slate-900">{car.name}</b> · {b.start} → {b.end}{b.reason ? ` · ${b.reason}` : ""}</span>
                  <button onClick={() => removeBlock(car.id, b.id)} data-testid={`block-remove-${b.id}`} className="text-rose-500 hover:text-rose-600 transition-colors"><Trash2 size={15} /></button>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
